export * from './src/email-marketing-v1-campaign-campaigns.universal.js';
